const e = "styles-module__email___zUBep", l = {
  email: e,
  "email--error": "styles-module__email--error___BOgFI",
  "email--valid": "styles-module__email--valid___XUvJ7"
};
export {
  l as default,
  e as email
};
